<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="1538" height="784" viewBox="0 0 1538 784" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="769" cy="769" r="768.5" stroke="#272D37" />
  <path
    d="M176.196 260.775L194.072 259.072L196.052 276.919L177.928 278.928L176.196 260.775Z"
    fill="url(#paint0_linear_1_18)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1_18"
      x1="185.246"
      y1="255.52"
      x2="185.587"
      y2="285.155"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#24CAFF" />
      <stop offset="0.7" stop-color="#FDB1A8" />
      <stop offset="1" stop-color="#FFA564" />
    </linearGradient>
  </defs>
</svg>
